<template>
  <client-only>
    <gmap-map
        :center="latlngs[0] || murica"
        :zoom="9"
        class="MAP">
      <gmap-marker
          v-for="(latlng, index) in latlngs"
          :key="index"
          :position="latlng"
          :icon="require('./assets/pin.svg')"/>
    </gmap-map>
  </client-only>
</template>

<script>

export default {
  name: 'work-area',
  props: {
    locations: {
      type: Array,
      default () { return []; },
      required: true,
    },
  },
  data () {
    return {
      murica: { lat: 41.525, lng: -99.861667 },
    };
  },
  computed: {
    latlngs () {
      return this.locations
        // Ensure location has latlng
        .filter(location => location.latlng && location.latlng.lat && location.latlng.lng)
        // Return only latlng
        .map(location => location.latlng);
    },
  },
};
</script>

<style scoped lang="scss">
  @import "~@homeservices/design-kit/tools";

  .MAP {
    width: 100%;
    height: 250px;

    @include tablet {
      height: 400px;
    }
  }
</style>
